<h1 matDialogTitle
    translate>
    {{ context.isNewEntry ? 'assets_modal_create_asset' : 'assets_modal_edit_asset' }}
</h1>

<form [formGroup]="formGroup"
      (submit)="onSubmit($event)">
    <mat-dialog-content *uiContentLoading="loadingData$ | async">
        <div class="layout-row layout-wrap layout-align-v-space-between">
            <div class="layout-column flex-65">
                <mat-form-field>
                    <input [uiAutofocus]
                           [placeholder]="'assets_modal_form_name' | translate"
                           matInput
                           formControlName="name"
                           name="name"
                           required
                           class="form-control"
                           data-cy="asset-name" />
                    <mat-error *ngIf="formGroup.get('name')!.hasError('maxlength')"
                               [translateParams]="{
                                  max: formGroup.get('name')!.getError('maxlength').requiredLength
                              }"
                               translate>
                        assets_modal_form_name_max_warning
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="layout-column flex-30">
                <mat-form-field>
                    <ui-suggest [items]="valueTypes"
                                [placeholder]="'assets_modal_form_type' | translate"
                                [value]="selectedType"
                                [clearable]="false"
                                [displayCount]="5"
                                [disabled]="!context.isNewEntry"
                                (selected)="context.data.type = $event.id"
                                formControlName="type"
                                data-cy="asset-type">
                    </ui-suggest>
                </mat-form-field>
            </div>
        </div>

        <mat-form-field>
            <input [placeholder]="'assets_modal_form_description' | translate"
                   matInput
                   formControlName="description"
                   name="description"
                   data-cy="asset-description" />
            <mat-error *ngIf="formGroup.get('description')!.hasError('maxlength')"
                       [translateParams]="{
                                  max: formGroup.get('description')!.getError('maxlength').requiredLength
                              }"
                       translate>
                assets_modal_form_description_max_warning
            </mat-error>
        </mat-form-field>

        <mat-form-field [hidden]="context.data.type !== 'Credential'">
            <ui-suggest #credentialStores
                        [items]="credentialStoreDropdownEntries"
                        [placeholder]="'assets_modal_form_credential_store' | translate"
                        [searchable]="true"
                        [clearable]="false"
                        [readonly]="loading$ | async"
                        [disabled]="credentialStoreDropdownEntries?.length <= 1"
                        [required]="context.data.type === 'Credential'"
                        formControlName="credentialStore"
                        data-cy="asset-type">
            </ui-suggest>
        </mat-form-field>

        <mat-slide-toggle #toggle
                          [hidden]="isModernFolder"
                          [checked]="isDefaultChecked"
                          (change)="isDefaultChecked = toggle.checked"
                          class="global-value-toggle"
                          data-cy="asset-toggle">
            {{ 'assets_modal_form_default_value' | translate }}
        </mat-slide-toggle>

        <ui-single-value-editor #singleValueEditor
                                [disabled]="!toggle.checked"
                                [asset]="context.data"
                                [readonly]="isReadOnly$ | async"
                                [credentialStoreChange$]="credentialStoreChange"
                                [type]="context.data.type"
                                [typeLabel]="selectedType[0].text"
                                [externalName]="formGroup.get('name')?.value || ''"
                                [isNewEntry]="context.isNewEntry"
                                [valueHintEnabled]="!isModernFolder">
        </ui-single-value-editor>

        <ui-robot-value-editor [hidden]="isModernFolder"
                               [asset]="context.data"
                               [readonly]="isReadOnly$ | async"
                               [credentialStoreChange$]="credentialStoreChange"
                               [type]="context.data.type"
                               [typeLabel]="selectedType[0].text"
                               [credentialStoreId]="credentialStores.value[0]?.id"
                               [default]="toggle.checked"
                               [isNewEntry]="context.isNewEntry">
        </ui-robot-value-editor>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button
                mat-dialog-close
                type="button"
                data-cy="asset-close">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <ng-container *ngLet="{
            loading: loading$ | async,
            isSingleValueInvalid: isDefaultChecked && singleValueEditor?.formGroup?.invalid,
            isMultiValueInvalid: robotValueEditor?.isEditorOpen || !robotValueEditor?.isEditorValid,
            isPerRobotWithoutValues: !isDefaultChecked && !robotValueEditor?.hasRobots
         } as state">
            <button [disabled]="
                        state.loading ||
                        state.isSingleValueInvalid ||
                        state.isMultiValueInvalid ||
                        state.isPerRobotWithoutValues ||
                        formGroup.invalid
                    "
                    [spinnerButtonLoading]="state.loading"
                    ui-spinner-button
                    mat-flat-button
                    type="submit"
                    color="primary"
                    data-cy="asset-submit">
                {{ (!context.isNewEntry ? 'modal_action_update' : 'modal_action_create') | translate }}
            </button>
        </ng-container>
    </mat-dialog-actions>
</form>
